<template>
  <div
    :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["id", "rangeValue"],
  data() {
    return {};
  },
  watch: {
    rangeValue: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },

  methods: {
    drawLine() {
      let value = this.rangeValue.slice(0, -1);
      if (document.getElementById(this.id) == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById(this.id));
      let myChart = this.$echarts.init(document.getElementById(this.id));
      myChart.setOption({}, true);
      let option = {
        title: {
          text: "年度综合节能率",
          x: "center",
          y: "90%",
          textStyle: {
            color: "#16E9F4",
            fontSize: 13,
          },
        },
        series: [
          {
            type: "pie",
            radius: ["72%", "50%"],
            silent: true,
            clockwise: true,
            data: [
              {
                value: value,
                name: "",
                itemStyle: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#E4FC62", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#41EEF4", // 100% 处的颜色
                      },
                    ],
                  },
                },
                label: {
                  formatter: function (params) {
                    return "{title|" + params.value + "}" + "{cell|%}";
                  },
                  position: "center",
                  show: true,
                  rich: {
                    title: {
                      fontSize: 18,
                      fontWeight: "bold",
                      color: "#fff",
                    },
                    cell: {
                      fontSize: 12,
                      color: "#B1B4BC",
                      padding: [5, 0, 0, 5],
                    },
                  },
                },
              },
              {
                value: 100 - value,
                name: "",
                label: {
                  show: false,
                },
                itemStyle: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#222", // 0% 处的颜色
                      },
                      {
                        offset: 0.3,
                        color: "#444", // 0% 处的颜色
                      },
                      {
                        offset: 0.6,
                        color: "#777", // 100% 处的颜色
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
</style>
